import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SideNavService } from 'src/app/core-flc/sidenav/sidenav.service';
import { RouterLinkEnum } from 'src/app/enums/router-link-enum';
import { SdtPositionControllerService } from 'src/app/server-api/services';
import { ListComponent } from 'src/app/utils-flc/list/list.component';

@Component({
  selector: 'app-sdt-position-list',
  templateUrl: './sdt-position-list.component.html',
  styleUrls: ['./sdt-position-list.component.css']
})
export class SdtPositionListComponent extends ListComponent {

  constructor(public override translate: TranslateService, public override sidenavService: SideNavService, private loadService: SdtPositionControllerService) {
      super(translate, sidenavService);

      translate
      .get(['sdt-position.button_create', 'icon_refresh', 'action_show'
    ])
      .subscribe((translations: string) => {
        this.topMenuIcons = [
          {icon: "add", title: translations['sdt-position.button_create'], routerLink: RouterLinkEnum.SDT_POSITIONS.toString() + "new", clickMethod: "dummy", checkDisable:true},
          {icon: "refresh", title: translations['icon_refresh'], routerLink: null, clickMethod: "refresh"}
        ];
        this.actions = [
          {icon: "playlist_add", title: translations['action_show'], routerLink: RouterLinkEnum.SDT_POSITIONS.toString(), clickMethod: "dummy"}
        ];
      });
      this.constructorName = 'SdtPositionList';
    }

  override ngOnInit(): void {

    this.placeholderSearchText = 'sdt-position.search';
    this.exportPrefix = 'sdt_position_';
    this.primarySort.active = 'chainage';
    this.defaultSort.active = 'chainage';
    this.profilesAllowEdit = 'ADMIN,ENGINEER';

    super.ngOnInit();

    this.displayedColumns = ['actions', 'name', 'chainage', 'actInclination', 'planInclination', 'prevInclination', 'directionGermany' , 'diffBermHeight', 'nrBerms', 'autoCorrection',
    'planBermSpacing', 'latestError','lock'];
  }

  override getItems() {
    super.getItems();
    this.loadService.getSdtPositions({ page: this.paginator.pageIndex, size: this.paginator.pageSize, sort: [this.dataSource.sort.active + ',' + this.dataSource.sort.direction], filter: this.filter.nativeElement.value }).subscribe(
      value  => {
        this.dataSource.data = value['content'];
        this.listIds = this.dataSource.data.map(d => d.id);
        this.totalElements = value['totalElements'];
        this.sidenavService.setLoading(false);
      }
    ,
      error => {
        console.error(JSON.stringify(error));
        this.sidenavService.setLoading(false);
      }
        ,
      () => {
        this.sidenavService.setLoading(false);
      }
    );
  }
}



